<div class="row d-flex">
  <form class="col-md-12" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-group form-block row">
      <div class="col-md-12">
        <sd-form-field-new label="Номер телефона">
          <input type="text" class="form-control" sdPhoneMaskFix formControlName="phone" />
        </sd-form-field-new>
        <sd-user-email-form></sd-user-email-form>
      </div>
    </div>

    <h4>Личные данные</h4>
    <div class="form-group row">
      <div class="col-md-12">
        <sd-form-field-new label="Имя">
          <input type="text" class="form-control" formControlName="firstName" />
        </sd-form-field-new>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <sd-form-field-new label="Фамилия">
          <input type="text" class="form-control" formControlName="lastName" />
        </sd-form-field-new>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <sd-form-field-new label="Дата рождения">
          <input type="date" class="form-control" placeholder="дд.мм.гггг" formControlName="dateOfBirth" />
        </sd-form-field-new>
      </div>
    </div>

    @if (isFormEditing()) {
      <div class="change-btn">
        <button
          sdButton
          [disabled]="!this.form.valid"
          [theme]="buttonThemes.Primary"
          [size]="buttonSizes.Large"
          class="btn btn-save"
          [attr.type]="'submit'"
        >
          сохранить
        </button>
        <button (click)="onReset()" class="btn-cancel">Отменить изменения</button>
      </div>
    }
  </form>
</div>
